<template>
  <v-container>
    <v-row>
      <v-col cols="2"></v-col>
      <v-col cols="6">
        <CRUDList class="mt-10"
    :canAdd="false" :canEdit="false" :canSave="false"
      :showSelect="false" :enableFixedHeaders="true" :displayTopPagination="false"
      :headers="headers"
      :baseCrudKey="baseCrudKey"
      tableWrapperDynamicClassname='elevation-3 mt-n5 ma-3 pt-0 pa-1 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='200'
      :defaultSortBy="defaultSortBy"
      @loadCRUDList = "loadExemptMfgApportionSummaryHandler"
       :footerTotalDisplayColumnWise="totalOfExemptApportionment"
      >
    </CRUDList>
      </v-col>

        <v-col cols="2">
          <ClarionDateControl class='input-text-size mt-n3'
              :isIsoDate='true' v-model='fromDate'
                label='From Date' />
                <ClarionDateControl class='input-text-size mt-n3'
              :isIsoDate='true' v-model='toDate'
                label='From Date' />
          <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" small @click="handleReport">
                  Print Exempt Mfg Report
                </v-btn>
              </template>
              <span>Print Exempt Mfg Report</span>
            </v-tooltip>
        </v-col>
        <v-col cols="2"></v-col>

    </v-row>

  </v-container>
</template>
<script>
// import { mapMutations, mapGetters } from 'vuex';
import { mapActions, mapGetters } from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import '../../../assets/style.css';
import { exemptMfgBelowHeader } from './ExemptMfgHeader.utils';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { clients } from '../../../util/clients';
// import { amountFormat } from '../../../util/shared/vue-global';

const { backendRest } = clients.direct;
export default {
  name: 'ExemptMfgFooter',
  components: {
    CRUDList,
    ClarionDateControl,
  },

  data() {
    return {
      baseCrudKey: 'exemptMfgSummaryKey',
      headers: exemptMfgBelowHeader,
      fromDate: '',
      toDate: '',
      apportionmentCrudKey: 'apportionmentCrudKey',
      totalOfExemptApportionment: ['Total', '', '', '', ''],
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria', 'items', 'item',
    ]),
    defaultSortBy() {
      return [
        {
          column: 'taxYear',
          direction: 'desc',
        },
      ];
    },
    criteriaStateForAppotion: {
      get() {
        return this.criteria(this.apportionmentCrudKey);
      },
      set(value) {
        this.setCriteria([this.apportionmentCrudKey, value]);
      },
    },
    criteriaStateForExemptMfg: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
  watch: {
    'criteriaStateForExemptMfg.taxYear': {
      handler() {
        this.loadExemptMfgApportionSummaryHandler();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('tax/taxExemptMfg', [
      'loadExemptMfgApportionSummary', 'getExemptApportionmentTotal',
    ]),
    ...mapActions('base/crud', ['setCriteria']),
    ...mapActions(['reAuth', 'flashWarn']),
    async handleReport() {
      if (!this.fromDate || !this.toDate) {
        this.flashWarn('Please select from date and to date !');
        return;
      }
      const { jwt } = await this.reAuth();
      const toUrl = `${backendRest.defaults.baseURL}/tax/exemptMfg-report?fromDate=${this.fromDate}&toDate=${this.toDate}&token=${jwt}`;
      window.open(toUrl);
    },
    async loadExemptMfgApportionSummaryHandler() {
      // Guard against timing issues - ensure taxYear exists
      if (!this.criteriaStateForExemptMfg.taxYear) {
        return;
      }

      const criteria = {
        needPaymentData: true,
        ...this.criteriaStateForAppotion,
        taxYear: this.criteriaStateForExemptMfg.taxYear,
      };
      await this.loadExemptMfgApportionSummary({ criteria, baseCrudKey: this.baseCrudKey });
      // await this.getExemptApportionmentTotalHandler();
    },
    // async getExemptApportionmentTotalHandler() {
    // const criteria = {
    //   needPaymentData: true,
    //   ...this.criteriaStateForAppotion,
    // };
    // const totals = await this.getExemptApportionmentTotal({ criteria });
    // this.totalOfExemptApportionment = [
    //   'Total:',
    //   amountFormat(totals.expectedAmount),
    //   amountFormat(totals.apportionmentAmount),
    //   amountFormat(totals.collectedAmount),
    //   amountFormat(totals.unCollectedAmount),
    // ];
    // },
  },

};
</script>

<style scoped>
.label {
  font-size: 0.85rem;
}
</style>
